export default "__VITE_PUBLIC_ASSET__46ca1493__"